import { css } from '../../../styles/theme';
import { isBrandAC, isBrandAP, isBrandDS, isBrandOV, isMarketGB } from 'src/constants/main';
import { StylesAC } from './Styles.AC';
import { StylesAP } from './Styles.AP';
import { StylesDS } from './Styles.DS';
import { StylesOV } from './Styled.OV';
import { StylesOVGB } from './Styled.OV.GB';

export const GlobalStyled = css`
    width: 100%;

    .linkButton {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        color: ${({ theme }) => theme.colors.primary};
        border: none;
        border-bottom: 1px solid transparent;
        background: none;
        cursor: pointer;
        padding: 0;
        margin: 0;
        width: auto;

        &:hover,
        &:focus-visible {
            border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
        }
    }

    .noLinkButton {
        border: 1px solid ${({ theme }) => theme.colors.primaryBlack};
        background: ${({ theme }) => theme.colors.white};
        width: 100%;

        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.primary};
            color: ${({ theme }) => theme.colors.white};
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }

    ${isBrandAC && StylesAC};
    ${isBrandAP && StylesAP};
    ${isBrandDS && StylesDS};
    ${isBrandOV && (isMarketGB ? StylesOVGB : StylesOV)};
`;
